import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import "./style.scss";

export const TabSelector = ({ defaultValue = "", items, onSelect }) => {
  return (
    <Tabs
      className="ldsrf-tab-selection"
      defaultActiveKey={`${defaultValue}`}
      id="ldsrfSelection"
      onSelect={onSelect}
    >
      {items &&
        items.map((item) => {
          return (
            <Tab
              eventKey={item.key}
              title={item.title}
              disabled={item.disabled}
            >
              {item.content}
            </Tab>
          );
        })}
    </Tabs>
  );
};

export default TabSelector;
